import { cn } from "@/modules/lib/utils"
import RestDayIcon from "@images/svgIcons/restDayIcon.svg"
import { word } from "@modules/core/utils/i18n"
import { Text } from "@/components/ui/baseUi/text"

type ProgramCalendarEventRestDayProps = {
  programName: string
  dayIndex: number
  duration: number
  className?: string
} & React.ComponentProps<"div">

export function ProgramCalendarEventRestDay({
  programName,
  dayIndex,
  duration,
  className,
  ...props
}: ProgramCalendarEventRestDayProps) {
  return (
    <div className={cn("flex flex-col items-center gap-3 py-2 text-center", className)} {...props}>
      <img src={RestDayIcon} width={60} alt="Rest day" />
      <div className="flex flex-col gap-1">
        <Text fontStyle="TM">{word("program.onOff.restDay")}</Text>
        <Text fontStyle="BS">{`${programName} (${dayIndex + 1}/${duration})`}</Text>
      </div>
    </div>
  )
}
